
import { h, app } from 'hyperapp';
import { tnOnCreate, tnOnRemove, Image, TextInput, TextArea, RadioButton, Checkbox, Select, Echo, Button, InputGroup, Control } from './front_component';

function sprintf(format) {
  var args = arguments;
  var offset = 1;
  return format.replace(/%([0-9]\$)?([^0-9])/g, function (match, f1, f2) {
    if (f2 == '%') {
      return '%';
    } else if (f2 == 's') {
      if (! f1) {
        return args[offset++];
      } else {
        return args[f1.slice(0, 1)];
      }
    }
  });
}

const nf = (amount) => {
  return number_format(amount, rule.taxPrecision, catalog.decPoint, catalog.thousandsSep);
}

const br = {nodeName:'br', attributes:{}, children:[]}

const _Tv = (x) => {
  x = _T(x)
  if (typeof x != 'string') return x

  const lines = x.split('\n')
  if (lines.length == 1) return lines[0]
  
  return lines.reduce((cur, line) => {
    return (cur.length == 0) ? [line] : [...cur, br, line]
  }, [])
}

const _T = (x) => {
  if (typeof x == 'undefined' || x === null) return null
  if (catalog.hasOwnProperty(x)) {
    return catalog[x]
  } else {
    console.log('TO TRANSLATE: ', x);
    return x;
  }
}

const scrollTo = (id, just = false) => {
  const pos = document.documentElement.scrollTop || document.body.scrollTop;
  const r = document.getElementById(id).getBoundingClientRect()
  const posBot = r.top + pos - (just ? 0 : 100)
  const posTop = r.top + pos - (just ? 1 : 150)
  if (posTop > pos) {
    const diff = Math.max((posTop - pos) / 8, 4)
    if (behavior.smoothScroll && posTop - pos > 4) {
      window.requestAnimationFrame(() => scrollTo(id, just))
      window.scrollTo(0, pos + diff)
    } else {
      window.scrollTo(0, posTop)
    }
  } else if (posBot < pos) {
    const diff = Math.max((pos - posBot) / 8, 4)
    if (behavior.smoothScroll && pos - posBot > 4) {
      window.requestAnimationFrame(() => scrollTo(id, just))
      window.scrollTo(0, pos - diff)
    } else {
      window.scrollTo(0, posBot)
    }
  }
}

const focusErrorInput = (prefix, ms) => {
  const ids = Object.keys(ms)
  if (ids.length == 0) return;
  const name = '.'+prefix+ids[0]
  const elem = document.querySelector(name);
  if (elem != null) {
    elem.focus();
    return;
  }
}

const findByProp = (name, val, arr) => {
  const len = arr.length
  for (let i = 0; i < len; i++) {
    if (arr[i][name] == val) return arr[i]
  }
  return undefined
}

const branchNo = (name, sep) => {
  const off = name.lastIndexOf(sep)
  const fragment = name.slice(off + 1)
  return parseInt(fragment)
}

// form = {datetime}
// state = {form, messages, loading}

const actions = {
  onchange: (ev) => (state, actions) => {
    const idx = branchNo(ev.currentTarget.name, '-')
    if (idx == 0) {
      const form = {datetime:[ev.currentTarget.value, ""]}
      const messages = {}
      return {...state, form, messages}
    } else {
      const form = {datetime:[state.form.datetime[0], ev.currentTarget.value]}
      const messages = {}
      return {...state, form, messages}
    }
  }, 
  onsubmit: (ev) => (state, actions) => {
    const datetime = state.form.datetime
    if (! datetime[0] || ! datetime[1]) {
      const messages = {datetime:'Select here'}
      window.requestAnimationFrame(() => {
        focusErrorInput('wq_attr-', messages)
      })
      return {...state, messages}
    }

    const glue = (formUrl.indexOf('?') == -1) ? '?' : '&'
    const name = "datetime"
    const value = datetime.join(' ')
    const url = formUrl + glue + name + "=" + encodeURIComponent(value)
    window.requestAnimationFrame(() => {
      window.location.href = url
    })
    return {...state, loading:true}
  }
}

const createState = () => {
  return {
    form: {datetime:["", ""]}, 
    messages: {}, 
    loading: false
  }
}

const dateDate = (date) => date.date
const dateCdate = (date) => date.cdate
const dateEnabled = (date) => date.times.length > 0

const view = (state, actions) => {
  const id = 'wqe-attr-DateTime'
  const dateName = 'dateTime-0'
  const timeName = 'dateTime-1'
  const timeOptions = state.form.datetime[0] ? findByProp('cdate', state.form.datetime[0], datetimeData).times : []
  return (
    <div class="wqe-Form">
      <div class="wqe-Attributes">
        <Control label={_T('Receiving DateTime')} required={true} message={_T(state.messages.datetime)} requiredText={_Tv('required')} id={id} xclass="wqe-belongs-attr wqe-for-dateTime" key={id}>
          <InputGroup gutter="mini" xclass="wqe-belongs-attr wqe-belongs-dateTime">
            <Select name={dateName} options={datetimeData} labelFunc={dateDate} valueFunc={dateCdate} enabledFunc={dateEnabled} value={state.form.datetime[0]} onchange={actions.onchange} xclass={`wqe-belongs-attr wqe-belongs-dateTime wqe_attr-datetime`} invalid={state.messages.datetime && !state.form.datetime[0]} clearable={false} placeholder={_T('Select Date')} />
            <Select name={timeName} key={state.form.datetime[0] || 'empty'} options={timeOptions} value={state.form.datetime[1]} onchange={actions.onchange} xclass={`wqe-belongs-attr wqe-belongs-dateTime wqe_attr-datetime`} disabled={!state.form.datetime[0]} invalid={state.messages.datetime && state.form.datetime[0]} clearable={false} placeholder={_T('Select Time')} />
          </InputGroup>
        </Control>
      </div>
      <Control label="" required={false} message={null} note={null} id="wqe-action" xclass="wqe-for-action">
        <InputGroup gutter="mini">
          <Button type="primary" onclick={actions.onsubmit} disabled={state.loading} xclass="wqe-belongs-action wqe-for-submit">{_Tv('Start Order')}</Button>
        </InputGroup>
      </Control>
    </div>
  )
}

const datetimeData = wqData.dateTime
const catalog = wqData.catalog;
const behavior = wqData.behavior;
const formUrl = wqData.formUrl;

const allActions = app(createState(), actions, view, document.getElementById('aforms-eats-datetime'))
